import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  addMultipleReqDocuments,
  addReqDocuments,
  documentUploaded,
  getMultipleReqDocAddedStatus,
  getOtherLocalDocUploadSasUrl,
  getReqDocAddedStatus,
  getUploadDocumentId,
  multipleReqDocumentAdded,
  reqDocumentAdded,
  uploadDocument,
} from "../../store/documents";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import { getCurrentUser } from "../../store/auth";
import UploadRepository from "./UploadRepository";
import {
  ddrmsRepoReqDocUploaded,
  getDdrmsRepositoryDocuments,
  getDdrmsRepoUploadedDocId,
  loadDdrmsRepositoryDocs,
  UploadDdrmsReqRepositoryDocs,
} from "../../store/ddrmsDocument";
import PurchaseOrderPopup from "../../../ReviewTools/PurchaseOrderPopup";
import { uploadFileToBlob } from "../../../services/blobUploadService";
import { getSubsCurrentWfTask, loadSubcontractorWfTask, subsCurrentWfTaskReceived } from "../../store/subcontractor";
import { getRecCurrentWfTask, loadRecruiterWfTask, recCurrentWfTaskReceived } from "../../store/recruiter";
import { candidateCurrentWfTaskReceived, getCandidateCurrentWfTask, loadCandidateWfTask } from "../../store/candidate";

const UploadOther = (props) => {
  const {
    handleOtherDocShowHide,
    otherDocShowHide,
    workflowTask,
    onReqDocs,
    applicantObj,
    uploadType,
    viewType,
    prevItem
  } = props;

  const [docName, setDocName] = useState("");
  const [docNotes, setDocNotes] = useState("");
  const [documents, setDocuments] = useState([]);
  const [btnProcess, setBtnProcess] = useState(null);
  const [selectedRepoDocs, setSelectedRepoDocs] = useState([]);
  const [refDocType, setRefDocType] = useState("local");
  const [isDragging, setIsDragging] = useState(false);
  const [selectedDocIds, setSelectedDocIds] = useState([]);
  const [selectedDocName, setSelectedDocName] = useState("");
  const [selectedKey, setSelectedKey] = useState("generate");
  const [poOrderType, setPoOrderType] = useState("add");
  const [wfTask, setWfTask] = useState(null);
  const [repoDocs, setRepoDocs] = useState([]);
  const [wfTaskReqCount, setWfTaskReqCount] = useState(0);
  const [repoLoading, setRepoLoading] = useState(false);
  const repositoryLoadStartedRef = useRef(false);

  const getFileIconDetails = (fileName) => {
    const ext = fileName?.split(".").pop().toLowerCase();
    switch (ext) {
      case "pdf":
        return { icon: "fa fa-file-pdf-o", color: "#ef4444", bg: "#fef2f2", border: "#fee2e2" };
      case "docx":
      case "doc":
        return { icon: "fa fa-file-word-o", color: "#2563eb", bg: "#eff6ff", border: "#dbeafe" };
      case "xlsx":
      case "xls":
      case "csv":
        return { icon: "fa fa-file-excel-o", color: "#16a34a", bg: "#f0fdf4", border: "#dcfce7" };
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
      case "svg":
        return { icon: "fa fa-file-image-o", color: "#8b5cf6", bg: "#f5f3ff", border: "#ede9fe" };
      default:
        return { icon: "fa fa-file-o", color: "#64748b", bg: "#f8fafc", border: "#e2e8f0" };
    }
  };

  const reqDocAddedStatusSelector = useSelector(getReqDocAddedStatus);
  const multipleReqDocAddedStatusSelector = useSelector(
    getMultipleReqDocAddedStatus
  );
  const uploadDocumentIdSelector = useSelector(getUploadDocumentId);
  const ddrmsRepoUploadedDocIdSelector = useSelector(getDdrmsRepoUploadedDocId);
  const otherLocalDocUploadSasUrlSelector = useSelector(getOtherLocalDocUploadSasUrl);
  const ddrmsRepositoryDocumentsSelector = useSelector(getDdrmsRepositoryDocuments);

  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
  const candidateCurrentWfTaskSelector = useSelector(getCandidateCurrentWfTask);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!otherDocShowHide) {
      setDocuments([]);
      setSelectedDocIds([]);
      setDocName("");
      setDocNotes("");
    }
  }, [otherDocShowHide]);

  useEffect(() => {
    if (workflowTask?.ciid > 0) {
      if (refDocType === "ddrms") {
        repositoryLoadStartedRef.current = true;
        setRepoLoading(true);
        dispatch(loadDdrmsRepositoryDocs(workflowTask.ciid));
      }

      setWfTask(workflowTask);
    }
    else if (applicantObj?.id) {

      if (prevItem?.applications?.length > 0 && refDocType === "ddrms") {
        repositoryLoadStartedRef.current = true;
        setRepoLoading(true);
        dispatch(loadDdrmsRepositoryDocs(prevItem.applications[0].ciid));
      }


      if (uploadType === "Subcontractor") {
        let partnerUsrId = applicantObj?.id;
        if (viewType === "candidateList")
          partnerUsrId = applicantObj?.subcontractor?.parentid;
        if (partnerUsrId > 0) {
          dispatch(loadSubcontractorWfTask(partnerUsrId));
          setWfTaskReqCount(wfTaskReqCount + 1)
        }
      }

      if (uploadType === "Recruiter") {
        let partnerUsrId = applicantObj?.id;
        if (viewType === "candidateList")
          partnerUsrId = applicantObj?.recruiter?.parentid;
        if (partnerUsrId > 0) {
          dispatch(loadRecruiterWfTask(partnerUsrId));
          setWfTaskReqCount(wfTaskReqCount + 1)
        }
      }

      if (uploadType === "Candidate") {
        dispatch(loadCandidateWfTask(applicantObj?.id));
        setWfTaskReqCount(wfTaskReqCount + 1);
      }
    }
  }, [])

  useEffect(() => {
    if (subsCurrentWfTaskSelector && subsCurrentWfTaskSelector !== 0) {
      setWfTask(subsCurrentWfTaskSelector)
      setWfTaskReqCount(0);
    }
    else if (subsCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.subcontractor?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1)
        dispatch(subsCurrentWfTaskReceived(null));
        setTimeout(() => {
          dispatch(loadSubcontractorWfTask(partnerUsrId));
        }, 1000);
      }
    }
  }, [subsCurrentWfTaskSelector]);

  useEffect(() => {
    if (recCurrentWfTaskSelector && recCurrentWfTaskSelector !== 0) {
      setWfTask(recCurrentWfTaskSelector)
      setWfTaskReqCount(0);
    } else if (recCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.recruiter?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1)
        dispatch(recCurrentWfTaskReceived(null));
        setTimeout(() => {
          dispatch(loadRecruiterWfTask(partnerUsrId));
        }, 1000);
      }
    }
  }, [recCurrentWfTaskSelector]);

  useEffect(() => {
    if (candidateCurrentWfTaskSelector && candidateCurrentWfTaskSelector !== 0) {
      setWfTask(candidateCurrentWfTaskSelector)
      setWfTaskReqCount(0)
    } else if (candidateCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
      setWfTaskReqCount(wfTaskReqCount + 1)
      dispatch(candidateCurrentWfTaskReceived(null));
      setTimeout(() => {
        dispatch(loadCandidateWfTask(applicantObj?.id));
      }, 1000);

    }
  }, [candidateCurrentWfTaskSelector]);

  useEffect(() => {
    if (refDocType === "ddrms" && wfTask?.ciid > 0) {
      repositoryLoadStartedRef.current = true;
      setRepoLoading(true);
      dispatch(loadDdrmsRepositoryDocs(wfTask.ciid));
    }
  }, [refDocType, wfTask])

  useEffect(() => {
    setRepoDocs(ddrmsRepositoryDocumentsSelector);
    if (repositoryLoadStartedRef.current) {
      setRepoLoading(false);
      repositoryLoadStartedRef.current = false;
    }
  }, [ddrmsRepositoryDocumentsSelector]);

  const handleSubmit = async () => {
    setBtnProcess(true);
    let task = { ...wfTask };
    task.performerId = parseInt(currentUser.id);
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        task.applicantId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        task.applicantId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        task.applicantId = applicantObj?.id;
    } else if (applicantObj?.id) {
      task.applicantId = applicantObj?.id;
    }

    if (documents.length > 0 || selectedRepoDocs.length > 0) {
      let updType = "sharing";
      let isPwd = "";

      var frmData = new FormData();
      frmData.append("workflowTask", JSON.stringify(task));
      frmData.append("userId", currentUser.id);
      frmData.append("docType", "req");
      frmData.append("updType", updType);
      frmData.append("isPwd", isPwd);

      if (refDocType === "local") {
        // documents.map((file, key) =>
        //   frmData.append("files[" + key + "]", file.file)
        // );
        frmData.append("files", JSON.stringify(documents.map((file) => ({ name: file.name, type: file.type, size: file.size }))));
        const result = await getConfirmAlert(
          "Warning",
          "Are you sure you want to send this Document?",
          "warning"
        );
        if (result.isConfirmed) dispatch(uploadDocument(frmData));
      } else if (refDocType === "ddrms") {
        frmData.append("message", "Required Document");
        const updDocs = selectedRepoDocs.map((doc) => {
          const newDoc = { ...doc };
          newDoc.docType = "req";
          return newDoc;
        });
        frmData.append("doc", JSON.stringify(updDocs));
        const result = await getConfirmAlert(
          "Warning",
          "Are you sure you want to send this Document?",
          "warning"
        );
        if (result.isConfirmed) dispatch(UploadDdrmsReqRepositoryDocs(frmData));
      }
    } else {
      const allReqDocs = [];
      selectedDocIds.forEach((id) => {
        const doc = onReqDocs.find((d) => d.id === id && d.name !== "Other");
        if (doc) {
          const frmObj = {
            formId: 0,
            documnetName: doc.name,
            notes: docNotes,
            ciid: task.ciid,
            iiid: task.iiid,
            wiid: task.wiid,
            performerId: task.applicantId ? parseInt(task.applicantId) : null,
            addedBy: currentUser.id ? parseInt(currentUser.id) : 0,
          };
          allReqDocs.push(frmObj);
        }
      });

      if (selectedDocName === "Other" && docName.trim() !== "") {
        const frmObj = {
          formId: 0,
          documnetName: docName,
          notes: docNotes,
          ciid: task.ciid,
          iiid: task.iiid,
          wiid: task.wiid,
          performerId: task.applicantId ? parseInt(task.applicantId) : null,
          addedBy: currentUser.id ? parseInt(currentUser.id) : 0,
        };
        allReqDocs.push(frmObj);
      }

      dispatch(addMultipleReqDocuments(allReqDocs));
      //dispatch(addReqDocuments(frmObj));
    }
  };

  useEffect(() => {
    if (uploadDocumentIdSelector || ddrmsRepoUploadedDocIdSelector) {
      let task = { ...wfTask };
      task.performerId = parseInt(currentUser.id);
      let usrId = currentUser.id;
      if (viewType === "candidateList") {
        if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
          task.applicantId = applicantObj.recruiter.parentid;
        else if (
          uploadType === "Subcontractor" &&
          applicantObj?.subcontractor?.parentid
        )
          task.applicantId = applicantObj.subcontractor.parentid;
        else if (uploadType === "Candidate" && applicantObj?.id)
          task.applicantId = applicantObj?.id;
      } else if (applicantObj?.id) {
        task.applicantId = applicantObj?.id;
      }

      let refDocId = uploadDocumentIdSelector;

      if (refDocType === "ddrms" && ddrmsRepoUploadedDocIdSelector) {
        refDocId = ddrmsRepoUploadedDocIdSelector;
      }

      const allReqDocs = [];
      selectedDocIds.forEach((id) => {
        const doc = onReqDocs.find((d) => d.id === id && d.name !== "Other");
        if (doc) {
          const frmObj = {
            formId: 0,
            documnetName: doc.name,
            notes: docNotes,
            ciid: task.ciid,
            iiid: task.iiid,
            wiid: task.wiid,
            performerId: task.applicantId ? parseInt(task.applicantId) : null,
            addedBy: currentUser.id ? parseInt(currentUser.id) : 0,
            refDocId: refDocId,
          };
          allReqDocs.push(frmObj);
        }
      });

      if (selectedDocName === "Other" && docName.trim() !== "") {
        const frmObj = {
          formId: 0,
          documnetName: docName,
          notes: docNotes,
          ciid: task.ciid,
          iiid: task.iiid,
          wiid: task.wiid,
          performerId: task.applicantId ? parseInt(task.applicantId) : null,
          addedBy: currentUser.id ? parseInt(currentUser.id) : 0,
          refDocId: refDocId,
        };
        allReqDocs.push(frmObj);
      }

      dispatch(addMultipleReqDocuments(allReqDocs));
      //dispatch(addReqDocuments(frmObj));
      //dispatch(documentUploaded(null));
      //dispatch(ddrmsRepoReqDocUploaded({status: null, docId: null}));
    }
  }, [uploadDocumentIdSelector, ddrmsRepoUploadedDocIdSelector]);

  useEffect(() => {
    if (otherLocalDocUploadSasUrlSelector && otherLocalDocUploadSasUrlSelector.length > 0) {
      documents.map((file, key) =>
        uploadFileToBlob(file, otherLocalDocUploadSasUrlSelector[key]?.uploadUrl, (progress) => {
          console.log(`Upload progress: ${progress}%`);
        })
      );
    }
  }, [otherLocalDocUploadSasUrlSelector]);

  useEffect(() => {
    if (reqDocAddedStatusSelector) {
      setBtnProcess(false);
      getAlert("", "Document Uploaded Successfully", "success");
      setDocName("");
      setDocNotes("");
      setDocuments([]);
      handleOtherDocShowHide("save");
      dispatch(documentUploaded(null));
      dispatch(ddrmsRepoReqDocUploaded({ status: null, docId: null }));
      dispatch(reqDocumentAdded(false));
    }
  }, [reqDocAddedStatusSelector]);

  useEffect(() => {
    if (multipleReqDocAddedStatusSelector) {
      setBtnProcess(false);
      getAlert("", "Document(s) Uploaded Successfully", "success");
      setDocName("");
      setDocNotes("");
      setDocuments([]);
      setSelectedDocIds([]);
      handleOtherDocShowHide("save");
      dispatch(documentUploaded(null));
      dispatch(ddrmsRepoReqDocUploaded({ status: null, docId: null }));
      dispatch(multipleReqDocumentAdded(false));
    }
  }, [multipleReqDocAddedStatusSelector]);

  const handleOnChange = (obj) => {
    console.log(obj);
  };

  const handleFileChange = (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
        size: file.size,
      };
      docs.push(doc);
    }
    setDocuments(docs);

    event.target.value = null;
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  // Drag & Drop Handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    const docs = files.map((file) => ({
      name: file.name,
      type: file.type,
      size: (file.size / 1024).toFixed(2),
      file: file,
    }));
    setDocuments((prev) => [...prev, ...docs]);
  };

  const handleSelectedDocIds = (e) => {
    const { value, checked } = e.target;
    console.log(value, checked);
    if (checked) {
      setSelectedDocIds((prev) => [...prev, parseInt(value)]);
      const doc = onReqDocs.find(
        (d) => d.id === parseInt(value) && d.name === "Other"
      );
      if (doc) setSelectedDocName(doc.name);
    } else {
      setSelectedDocIds((prev) => prev.filter((id) => id !== parseInt(value)));
      const doc1 = onReqDocs.find(
        (d) => d.id === parseInt(value) && d.name === "Other"
      );
      if (doc1) setSelectedDocName("");
    }
  };

  const handleSelectedKey = (key) => {
    setSelectedKey(key);
  };

  const handlePurchaseShowHide = (item, type, poOrderType) => {
    // setSelectedDocId(0);
    // setSelectedDoc(null);
    // setPoOrderType(poOrderType);
    // setPurchaseShowHide(true);
    // if (item) {
    //     setSelectedItem(item);
    // }
  };
  const handleSignUnsignPo = (poOrder) => {
    // Logic to sign or unsign the purchase order
  };
  const handleRefreshPoOrders = () => {
    // Logic to refresh the purchase orders
    //handleModalShowHide("save");
    if (selectedKey !== "poOrder") handleOtherDocShowHide("save");
  };

  return (
    <>
      <style>{`
        @keyframes uoFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
        }
        .modal-backdrop {
            z-index: 1080 !important;
        }
        .modal {
            z-index: 1090 !important;
        }
        .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
        }
        .modal.fade .uo-modal.modal-dialog {
            transform: scale(0.95) !important;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .uo-modal.modal-dialog {
            transform: scale(1) !important;
        }
        .uo-modal {
            max-width: 90% !important;
            width: 1200px !important;
        }
        .uo-modal .modal-content {
            border: 0;
            border-radius: 16px;
            overflow: hidden;
            background: #ffffff;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            max-height: calc(100vh - 60px);
            display: flex;
            flex-direction: column;
        }
        .uo-shell,
        .uo-shell button,
        .uo-shell input,
        .uo-shell select,
        .uo-shell textarea {
            font-family: "Open Sans", "Segoe UI", Roboto, sans-serif !important;
        }
        .uo-shell {
            animation: uoFadeIn 0.25s ease both;
            background: #ffffff;
            max-height: calc(100vh - 60px);
            display: flex;
            flex-direction: column;
            min-height: 0;
        }
        .uo-header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 18px;
            padding: 22px 24px 18px;
            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
            border-bottom: 1px solid #f1f5f9;
        }
        .uo-header-left {
            display: flex;
            align-items: flex-start;
            gap: 14px;
            min-width: 0;
            flex: 1;
            text-align: left;
        }
        .uo-icon-box {
            width: 44px;
            height: 44px;
            border-radius: 12px;
            background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 18px;
            flex-shrink: 0;
            box-shadow: 0 8px 16px rgba(37, 99, 235, 0.2);
        }
        .uo-title { font-size: 18px; font-weight: 800; color: #0f172a; line-height: 1.2; margin: 0; }
        .uo-subtitle { font-size: 13px; color: #64748b; margin: 6px 0 0; }
        .uo-meta-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
        .uo-meta-pill {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 4px 10px;
            border-radius: 99px;
            background: #ffffff;
            border: 1px solid #e2e8f0;
            color: #475569;
            font-size: 12px;
            font-weight: 700;
        }
        .uo-meta-pill i { font-size: 11px; color: #2563eb; }
        .uo-close-btn {
            width: 38px;
            height: 38px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            border: 1px solid #cbd5e1;
            background: #ffffff;
            color: #475569;
            cursor: pointer;
            transition: all 0.15s ease;
            flex-shrink: 0;
        }
        .uo-close-btn:hover { background: #f8fafc; border-color: #94a3b8; color: #0f172a; transform: translateY(-1px); }
        .uo-body {
            padding: 0 24px 24px;
            background: #ffffff;
            overflow: hidden;
            min-height: 0;
            display: flex;
            flex-direction: column;
            flex: 1;
        }
        .uo-tab-bar {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 2px;
            padding-top: 14px;
            margin-bottom: 16px;
            border-bottom: 1px solid #e2e8f0;
            overflow: visible;
            flex: 0 0 auto;
        }
        .uo-tab-btn {
            min-height: 44px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 10px 18px;
            border: 0;
            border-radius: 8px 8px 0 0;
            background: transparent;
            color: #64748b;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            transition: color 0.2s ease, background 0.2s ease;
            position: relative;
            white-space: nowrap;
            outline: none;
        }
        .uo-tab-btn:hover { color: #1e293b; background: rgba(37, 99, 235, 0.04); }
        .uo-tab-btn.active { color: #2563eb; font-weight: 700; background: rgba(37, 99, 235, 0.06); }
        .uo-tab-btn::after {
            content: "";
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 2px;
            background: #2563eb;
            border-radius: 2px 2px 0 0;
            transform: scaleX(0);
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .uo-tab-btn.active::after { transform: scaleX(1); }
        .uo-tab-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            background: #f1f5f9;
            color: #64748b;
            border: 1px solid #e2e8f0;
            line-height: 1;
        }
        .uo-tab-btn.active .uo-tab-badge {
            background: rgba(37, 99, 235, 0.1);
            color: #1d4ed8;
            border-color: rgba(37, 99, 235, 0.2);
        }
        .uo-panel {
            border: 1px solid rgba(226, 232, 240, 0.95);
            border-radius: 14px;
            overflow: hidden;
            background: #ffffff;
            box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
            min-height: 0;
            display: flex;
            flex-direction: column;
            flex: 1;
        }
        .uo-toolbar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;
            padding: 16px 20px;
            background: #f8fafc;
            border-bottom: 1px solid #e2e8f0;
        }
        .uo-section-label {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            margin: 0;
            color: #334155;
            font-size: 12px;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            text-align: left;
        }
        .uo-section-label i { color: #2563eb; }
        .uo-note { margin: 6px 0 0; color: #64748b; font-size: 12.5px; font-weight: 600; text-align: left; }
        .uo-content-scroll {
            padding: 24px;
            overflow-y: auto;
            flex: 1;
            min-height: 0;
            scrollbar-width: thin;
            scrollbar-color: #94a3b8 #f1f5f9;
        }
        .uo-content-scroll::-webkit-scrollbar { width: 6px; height: 6px; }
        .uo-content-scroll::-webkit-scrollbar-track { background: transparent; }
        .uo-content-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        .uo-content-scroll::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
        .uo-two-col {
            display: flex;
            gap: 24px;
            align-items: stretch;
            width: 100%;
        }
        .uo-left-panel {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            gap: 16px;
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            padding: 20px;
            box-shadow: 0 4px 12px rgba(15, 23, 42, 0.01);
        }
        .uo-right-panel {
            width: 540px;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            gap: 20px;
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            padding: 20px;
            box-shadow: 0 4px 12px rgba(15, 23, 42, 0.01);
        }
        @media (max-width: 992px) {
            .uo-two-col { flex-direction: column; }
            .uo-right-panel { width: 100%; }
        }
        .uo-form-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
            text-align: left;
        }
        .uo-label {
            font-size: 11.5px;
            font-weight: 800;
            color: #475569;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin: 0;
        }
        .uo-doc-card-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
        .uo-doc-card-row {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 12px 16px;
            border: 1px solid #e2e8f0;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.15s ease;
            user-select: none;
            background: #ffffff;
            text-align: left;
        }
        .uo-doc-card-row:hover {
            border-color: #cbd5e1;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
        }
        .uo-doc-card-row.selected {
            background: #f8fbff;
            border-color: #93c5fd;
            border-left: 4px solid #2563eb;
            padding-left: 12px;
        }
        .uo-checkbox-wrap {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            position: relative;
            width: 18px;
            height: 18px;
            flex-shrink: 0;
        }
        .uo-checkbox-custom {
            width: 18px;
            height: 18px;
            border: 2px solid #cbd5e1;
            border-radius: 4px;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .uo-checkbox-custom::after {
            content: "";
            display: none;
            width: 5px;
            height: 9px;
            border: solid white;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
            margin-bottom: 2px;
        }
        .uo-doc-card-row.selected .uo-checkbox-custom {
            background-color: #2563eb;
            border-color: #2563eb;
        }
        .uo-doc-card-row.selected .uo-checkbox-custom::after {
            display: block;
        }
        .uo-doc-name {
            font-size: 13.5px;
            font-weight: 700;
            color: #0f172a;
            flex: 1;
        }
        .uo-doc-icon {
            font-size: 15px;
            color: #64748b;
            flex-shrink: 0;
        }
        .uo-doc-card-row.selected .uo-doc-icon {
            color: #2563eb;
        }
        .uo-choice-cards {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
            margin-top: 4px;
        }
        .uo-choice-card {
            border: 1px solid #e2e8f0;
            border-radius: 10px;
            background: #ffffff;
            padding: 14px;
            cursor: pointer;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            gap: 12px;
            align-items: flex-start;
            text-align: left;
        }
        .uo-choice-card:hover {
            border-color: #cbd5e1;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
        }
        .uo-choice-card.active {
            border-color: #2563eb;
            background: rgba(37, 99, 235, 0.02);
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
        }
        .uo-choice-icon {
            width: 32px;
            height: 32px;
            border-radius: 8px;
            background: #f1f5f9;
            color: #64748b;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            flex-shrink: 0;
        }
        .uo-choice-card.active .uo-choice-icon {
            background: #eff6ff;
            color: #2563eb;
        }
        .uo-choice-content {
            display: flex;
            flex-direction: column;
            gap: 2px;
            min-width: 0;
        }
        .uo-choice-title { font-size: 13px; font-weight: 700; color: #0f172a; }
        .uo-choice-desc { font-size: 11px; color: #64748b; line-height: 1.3; }

        .uo-input, .uo-textarea {
            width: 100%;
            min-height: 40px;
            padding: 10px 14px;
            border-radius: 8px;
            border: 1px solid #cbd5e1;
            background-color: #ffffff;
            color: #0f172a;
            font-size: 14px;
            font-weight: 600;
            transition: all 0.15s ease;
            outline: none;
        }
        .uo-input:focus, .uo-textarea:focus {
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
        }
        .uo-drop-zone {
            border: 2px dashed #cbd5e1;
            border-radius: 12px;
            background: #f8fafc;
            padding: 32px 20px;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
        }
        .uo-drop-zone:hover {
            border-color: #94a3b8;
            background: #f1f5f9;
        }
        .uo-drop-zone.dragging {
            border-color: #2563eb;
            background: #eff6ff;
        }
        .uo-drop-icon {
            width: 44px;
            height: 44px;
            border-radius: 10px;
            background: #ffffff;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #64748b;
            box-shadow: 0 4px 12px rgba(15, 23, 42, 0.03);
            font-size: 18px;
        }
        .uo-drop-zone.dragging .uo-drop-icon {
            color: #2563eb;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.1);
        }
        .uo-drop-text { font-size: 13px; font-weight: 700; color: #334155; }
        .uo-drop-subtext { font-size: 11px; color: #64748b; }

        .uo-file-list {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-top: 12px;
        }
        .uo-file-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 8px 12px;
            border: 1px solid #e2e8f0;
            border-radius: 8px;
            background: #f8fafc;
            gap: 12px;
        }
        .uo-file-info {
            display: flex;
            align-items: center;
            gap: 8px;
            min-width: 0;
        }
        .uo-file-name {
            font-size: 12.5px;
            font-weight: 700;
            color: #334155;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .uo-file-size {
            font-size: 11px;
            font-weight: 700;
            background: #f1f5f9;
            color: #475569;
            padding: 2px 6px;
            border-radius: 4px;
            border: 1px solid #e2e8f0;
            white-space: nowrap;
        }
        .uo-file-remove {
            background: none;
            border: none;
            cursor: pointer;
            color: #64748b;
            transition: color 0.15s ease;
            padding: 4px;
            display: inline-flex;
        }
        .uo-file-remove:hover { color: #ef4444; }

        .uo-footer {
            padding: 16px 24px;
            background: #f8fafc;
            border-top: 1px solid #e2e8f0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 10px;
            flex-shrink: 0;
        }
        .uo-btn {
            min-height: 38px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 8px 16px;
            border-radius: 8px;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.15s ease;
            white-space: nowrap;
            border: 1px solid #cbd5e1;
            background: #ffffff;
            color: #334155;
        }
        .uo-btn:hover:not(:disabled) {
            background: #f8fafc;
            border-color: #94a3b8;
            transform: translateY(-1px);
        }
        .uo-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
        .uo-btn.primary {
            background: #2563eb;
            border-color: #2563eb;
            color: #ffffff;
        }
        .uo-btn.primary:hover:not(:disabled) {
            background: #1d4ed8;
            border-color: #1d4ed8;
        }
      `}</style>

      <Modal
        show={otherDocShowHide}
        size="xl"
        centered
        onHide={handleOtherDocShowHide}
        dialogClassName="uo-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="p-0">
          <div className="uo-shell">
            <div className="uo-header">
              <div className="uo-header-left">
                <div className="uo-icon-box">
                  <i className="fa fa-cloud-upload" />
                </div>
                <div className="uo-title-block">
                  <h2 className="uo-title">Upload Required Documents</h2>
                  <p className="uo-subtitle">Upload or select required files for the performing candidate/partner.</p>
                  <div className="uo-meta-row">
                    <span className="uo-meta-pill">
                      <i className="fa fa-briefcase" /> Performer: {uploadType || "General"}
                    </span>
                    {wfTask?.ciid > 0 && (
                      <span className="uo-meta-pill">
                        <i className="fa fa-hashtag" /> CIID: {wfTask.ciid}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="uo-close-btn"
                onClick={handleOtherDocShowHide}
                title="Close"
              >
                <i className="fa fa-times" />
              </button>
            </div>

            <div className="uo-body">
              {/* <div className="uo-tab-bar" role="tablist" aria-label="Upload document actions">
                <button
                  type="button"
                  role="tab"
                  aria-selected={selectedKey === "generate"}
                  className={`uo-tab-btn ${selectedKey === "generate" ? "active" : ""}`}
                  onClick={() => handleSelectedKey("generate")}
                >
                  <span className="uo-tab-text">Required Documents</span>
                  <span className="uo-tab-badge">{selectedDocIds.length}</span>
                </button>
                {viewType === "candidateList" && (
                  <button
                    type="button"
                    role="tab"
                    aria-selected={selectedKey === "poOrder"}
                    className={`uo-tab-btn ${selectedKey === "poOrder" ? "active" : ""}`}
                    onClick={() => handleSelectedKey("poOrder")}
                  >
                    <span className="uo-tab-text">Purchase Order</span>
                    <span className="uo-tab-badge"><i className="fa fa-file-text-o" /></span>
                  </button>
                )}
              </div> */}

              {selectedKey === "generate" && (
                <div className="uo-panel" role="tabpanel">
                  <div className="uo-toolbar">
                    <div>
                      <div className="uo-section-label">
                        <i className="fa fa-folder-open-o" /> Select & Upload Documents
                      </div>
                      <p className="uo-note">Choose one or more required document types to upload from your local drive or DDRMS repository.</p>
                    </div>
                  </div>
                  <div className="uo-content-scroll">
                    <div className="uo-two-col">
                      <div className="uo-left-panel">
                        <div className="uo-form-group">
                          <label className="uo-label">Required Document Checklist</label>
                          <div className="uo-doc-card-list">
                            {onReqDocs.map((doc) => {
                              const isSelected = selectedDocIds.includes(doc.id);
                              return (
                                <div
                                  key={doc.id}
                                  className={`uo-doc-card-row ${isSelected ? "selected" : ""}`}
                                  onClick={() => {
                                    const e = { target: { value: doc.id, checked: !isSelected } };
                                    handleSelectedDocIds(e);
                                  }}
                                >
                                  <span className="uo-checkbox-wrap">
                                    <span className="uo-checkbox-custom" />
                                  </span>
                                  <span className="uo-doc-name">{doc.name}</span>
                                  <span className="uo-doc-icon">
                                    <i className={doc.name === "Other" ? "fa fa-ellipsis-h" : "fa fa-file-o"} />
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>

                      <div className="uo-right-panel">
                        {selectedDocName === "Other" && (
                          <div className="uo-form-group">
                            <label htmlFor="uo-other-name" className="uo-label">Other Document Name</label>
                            <input
                              id="uo-other-name"
                              type="text"
                              className="uo-input"
                              placeholder="e.g. Candidate Passport Copy"
                              value={docName}
                              onChange={({ target }) => setDocName(target.value)}
                            />
                          </div>
                        )}

                        <div className="uo-form-group">
                          <label htmlFor="uo-doc-notes" className="uo-label">Document Notes / Description</label>
                          <textarea
                            id="uo-doc-notes"
                            rows={3}
                            className="uo-textarea"
                            placeholder="Add file notes, guidelines, or details context..."
                            value={docNotes}
                            onChange={({ target }) => setDocNotes(target.value)}
                          />
                        </div>

                        <div className="uo-form-group">
                          <label className="uo-label">Upload Reference Document Source</label>
                          <div className="uo-choice-cards">
                            <div
                              className={`uo-choice-card ${refDocType === "local" ? "active" : ""}`}
                              onClick={() => setRefDocType("local")}
                            >
                              <div className="uo-choice-icon">
                                <i className="fa fa-laptop" />
                              </div>
                              <div className="uo-choice-content">
                                <span className="uo-choice-title">Local files</span>
                                <span className="uo-choice-desc">Select local files</span>
                              </div>
                            </div>
                            <div
                              className={`uo-choice-card ${refDocType === "ddrms" ? "active" : ""}`}
                              onClick={() => setRefDocType("ddrms")}
                            >
                              <div className="uo-choice-icon">
                                <i className="fa fa-database" />
                              </div>
                              <div className="uo-choice-content">
                                <span className="uo-choice-title">DDRMS repo</span>
                                <span className="uo-choice-desc">Select repository files</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {refDocType === "local" && (
                          <div className="uo-form-group" style={{ borderTop: "1px solid #f1f5f9", paddingTop: "16px" }}>
                            <label className="uo-label">Attachment Files</label>
                            <div
                              className={`uo-drop-zone ${isDragging ? "dragging" : ""}`}
                              onDragOver={handleDragOver}
                              onDragLeave={handleDragLeave}
                              onDrop={handleDrop}
                              onClick={() => fileInputRef.current.click()}
                            >
                              <div className="uo-drop-icon">
                                <i className="fa fa-cloud-upload" />
                              </div>
                              <span className="uo-drop-text">Drag & drop files here</span>
                              <span className="uo-drop-subtext">or click to browse from device</span>
                            </div>
                            <input
                              type="file"
                              multiple
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />

                            {documents.length > 0 && (
                              <div className="uo-file-list">
                                {documents.map((file, idx) => {
                                  const details = getFileIconDetails(file.name);
                                  return (
                                    <div key={idx} className="uo-file-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", border: "1px solid " + details.border, borderRadius: "10px", background: details.bg, gap: "12px", boxShadow: "0 1px 2px rgba(15, 23, 42, 0.02)" }}>
                                      <div className="uo-file-info" style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0, flex: 1 }}>
                                        <div style={{ width: "30px", height: "30px", borderRadius: "6px", display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#ffffff", border: "1px solid " + details.border, color: details.color, fontSize: "14px", flexShrink: 0 }}>
                                          <i className={details.icon} />
                                        </div>
                                        <span className="uo-file-name" title={file.name} style={{ fontSize: "13px", fontWeight: "700", color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</span>
                                      </div>
                                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <span className="uo-file-size" style={{ fontSize: "11px", fontWeight: "700", background: "#ffffff", color: "#475569", padding: "2px 8px", borderRadius: "6px", border: "1px solid " + details.border, whiteSpace: "nowrap" }}>{file.size} KB</span>
                                        <button
                                          type="button"
                                          className="uo-file-remove"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleFileRemove(file);
                                          }}
                                          style={{ background: "none", border: "none", cursor: "pointer", color: "#64748b", transition: "color 0.15s ease", padding: "4px", display: "inline-flex" }}
                                        >
                                          <i className="fa fa-times" />
                                        </button>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        )}

                        {refDocType === "ddrms" && (
                          <div className="uo-form-group" style={{ borderTop: "1px solid #f1f5f9", paddingTop: "16px" }}>
                            <label className="uo-label">Select DDRMS Repository Files</label>
                            <UploadRepository
                              repoDocs={repoDocs}
                              setSelectedRepoDocs={setSelectedRepoDocs}
                              loading={repoLoading}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {selectedKey === "poOrder" && viewType === "candidateList" && (
                <div className="uo-panel" role="tabpanel">
                  <div className="uo-toolbar">
                    <div>
                      <div className="uo-section-label">
                        <i className="fa fa-file-text-o" /> Purchase Order Workflow
                      </div>
                      <p className="uo-note">Configure, sign, and verify the purchase orders for recruitment processes.</p>
                    </div>
                  </div>
                  <div className="uo-content-scroll" style={{ padding: "0" }}>
                    <PurchaseOrderPopup
                      purchaseShowHide={true}
                      handlePurchaseShowHide={handlePurchaseShowHide}
                      candidateObj={applicantObj}
                      workflowTask={wfTask}
                      poOrderType={poOrderType}
                      item={{
                        partnerType:
                          uploadType === "Recruiter"
                            ? "Recruiter"
                            : "Sub-Contractors",
                      }}
                      handleSignUnsignPo={handleSignUnsignPo}
                      handleRefreshPoOrders={handleRefreshPoOrders}
                      renderType="generate"
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="uo-footer">
              <button
                type="button"
                className="uo-btn"
                onClick={handleOtherDocShowHide}
              >
                <i className="fa fa-times" /> Cancel
              </button>
              {selectedKey === "generate" && (
                <button
                  type="button"
                  className="uo-btn primary"
                  disabled={btnProcess || selectedDocIds.length === 0}
                  onClick={handleSubmit}
                >
                  {btnProcess ? (
                    <i className="fa fa-circle-o-notch fa-spin" />
                  ) : (
                    <i className="fa fa-cloud-upload" />
                  )} Attach & Send
                </button>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UploadOther;
